import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RenewToken = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const makeApiCall = async () => {
            const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
                const [key, ...valueParts] = cookie.split('=');
                const value = valueParts.join('=');
                acc[key] = decodeURIComponent(value);
                return acc;
            }, {});

            if (!cookies['u'] || !cookies['htr']) {
                navigate('/dashboard/@login/');
                return;
            }

            try {
                const response = await fetch('https://jaquesbot.fr/api/V4/botConfig/intraConnect/panelAuth/renew', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'u': cookies['u'],
                        'htr': cookies['htr'],
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                // console.log('Cookie actuel :', cookies['htr']);

                if (data && data.htr) {
                    const secureFlag = window.location.protocol === 'https:' ? 'Secure;' : '';
                    document.cookie = `htr=${decodeURIComponent(data.htr)}; path=/; SameSite=Strict; ${secureFlag}`;
                    // console.log("Update Cookie :", decodeURIComponent(data.htr));
                } else {
                    throw new Error('Invalid token data received');
                }
            } catch (err) {
                console.error('Failed to renew token:', err);
                navigate('/dashboard/@login/');
            }
        };

        makeApiCall();
    }, [navigate]);

    return null;
};

export default RenewToken;
